const selectHost = (service?:string, appEnvironment?: string) => {
  let port =3001
  if(service==="core-service")
     port = 3004
	else if(service==="octopus-service")
			port = 3003
  else if(service==="admin-service")
     port = 3005
  else if(service==="octopus-service")
     port = 3003
  const prodHost = process.env.REACT_APP_API_HOST || "";
  const stagingHost = process.env.REACT_APP_API_HOST_STAGING || "";

  switch (appEnvironment) {
    case "local":
      return {
        protocol: "http:",
        hostname: "localhost",
        port: port,
        credentials: "include",
        mode: "cors",
      } as const;
    case "development":
      return {
        protocol: "http:",
        hostname: process.env.REACT_APP_API_HOST || "13.53.33.39",
        port: port,
        credentials: "include",
        mode: "cors",
      } as const;
    case "production":
      return {
        protocol: "https:",
        hostname: prodHost,
        credentials: "include",
        mode: "cors",
      } as const;
    case "staging":
      return {
        protocol: "https:",
        hostname: stagingHost,
        credentials: "include",
        mode: "cors",
      } as const;
    default:
      return {
        protocol: "https:",
        hostname: "",
        credentials: "include",
        mode: "cors",
      } as const;
  }
};

export default selectHost;
